// @ts-nocheck
// Make variant radio buttons equal width within each set
function equalizeVariantRadioWidths() {
  const radioContainers = document.querySelectorAll('.product-dynamic-variant-picker__radios:not(.decoration-dropdown__radios)');

  radioContainers.forEach(container => {
    const radioSpans = container.querySelectorAll('.product-dynamic-variant-picker__radio-option span');
    let maxWidth = 0;

    // Find the maximum width
    radioSpans.forEach((span) => {
      const width = span.offsetWidth;
      if (width > maxWidth) {
        maxWidth = width;
      }
    });

    // Set all spans to the maximum width and center text
    radioSpans.forEach((span) => {
      span.style.width = maxWidth + 'px';
      span.style.justifyContent = 'center';
    });
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', equalizeVariantRadioWidths);

// Run on window resize
window.addEventListener('resize', equalizeVariantRadioWidths);
